export class AuthenticationInput {
    constructor(email, password, rememberMe, otp) {
        this.email = email;
        this.password = password;
        this.rememberMe = rememberMe;
        this.otp = otp;
    }
}
